import React from 'react';
import Icon from '../Icons/Icon';
import { classNames } from '../../Services/helpers';

const Tile = ({title, icon, options, children, flush = false}) => {
    return <div className="">
        {(title || icon || options) && <div className="w-full inline-flex flex-row items-center justify-between text-brand fill-brand p-2">
            <div className="flex flex-row items-center gap-2 font-bold text-lg">
                {icon && <Icon icon={icon} size="2x" />}
                {title}
            </div>
            <div className="flex flex-row items-center gap-2 text-muted text-sm">
                {options}
            </div>
        </div>}
        <div className={classNames(flush || 'p-4 surface-1 rounded-lg surface-outline')}>
            {children}
        </div>
    </div>;
}

export default Tile;
